export default {"src":"/_next/static/media/Home-1.91688112.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};